import { mapGetters } from 'vuex'
import ChatGPT from '@/components/ChatGPT/ChatGPT.vue'

export default {
  name: 'AdminCopilot',
  components: {
    ChatGPT
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    isAdmin () {
      return !!this.user?.admin
    }
  }
}
